var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.542969 9.95098V12.1904H6.48994V10.7796H1.95538V9.95098C1.95538 9.47323 4.28213 8.38338 6.48994 8.38338C7.20358 8.39085 7.90978 8.48789 8.59369 8.66704L9.72361 7.5324C8.68289 7.18156 7.605 6.98748 6.48994 6.96508C4.50514 6.96508 0.542969 7.95789 0.542969 9.95098ZM6.48994 0.246826C4.84709 0.246826 3.51646 1.58301 3.51646 3.23272C3.51646 4.88242 4.84709 6.21861 6.48994 6.21861C8.1328 6.21861 9.46343 4.88242 9.46343 3.23272C9.46343 1.58301 8.1328 0.246826 6.48994 0.246826ZM6.48994 4.72566C5.67223 4.72566 5.0032 4.0613 5.0032 3.23272C5.0032 2.40413 5.67223 1.73977 6.48994 1.73977C7.30765 1.73977 7.97669 2.4116 7.97669 3.23272C7.97669 4.05384 7.31509 4.72566 6.48994 4.72566ZM15.1874 7.22635L14.444 7.97282L12.9201 6.47988L13.6635 5.7334C13.7399 5.65818 13.8427 5.61604 13.9497 5.61604C14.0567 5.61604 14.1595 5.65818 14.2359 5.7334L15.1874 6.68889C15.3435 6.84565 15.3435 7.10691 15.1874 7.26367M7.97669 11.3991L12.4815 6.87551L14.0054 8.36845L9.5452 12.8995H7.97669V11.3991Z",
    fill: "#727D9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile1);
export default __webpack_public_path__ + "static/media/profile1.ac9a8c6441814384d3527db409578500.svg";
export { ForwardRef as ReactComponent };